/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesOfSolesMemberDayFact } from '../../models/sales-of-soles-member-day-fact';

export interface DwhQueryControllerSalesOfSolesMember$Params {
  startYear: number;
  endYear: number;
}

export function dwhQueryControllerSalesOfSolesMember(http: HttpClient, rootUrl: string, params: DwhQueryControllerSalesOfSolesMember$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesOfSolesMemberDayFact>>> {
  const rb = new RequestBuilder(rootUrl, dwhQueryControllerSalesOfSolesMember.PATH, 'get');
  if (params) {
    rb.query('startYear', params.startYear, {});
    rb.query('endYear', params.endYear, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesOfSolesMemberDayFact>>;
    })
  );
}

dwhQueryControllerSalesOfSolesMember.PATH = '/api/dwh/query/sales-of-soles-member';
